import React from 'react';

import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const SuitableFor = ({ classes, data }) => {

  return (
    <div className={`suitable-for ${classes}`}>
      <h2 className="detail-view__section-header">Velegnet til:</h2>

      <div className="suitable-for__list">
        { data.map(kind =>
          <div className="suitable-for__list-item" key={`suitable-for-${kind.id}`}>
            <SvgIcon name={kind.id} size={20} />
            { kind.name }
          </div>
        )}
      </div>
    </div>
  )
}

export default SuitableFor;
